import moment from 'moment'
import Image from '../../../_metronic/images/sidebarmenuphone.png'
import {checkEmptyData, statusBadgeClassName} from '../../../utils/helper'
export const renderTableHeader = (config: any, selectedCount?: number, paginatedCount?: number) => {
  const {columnWidth, headerName, type, checkboxHandler} = config
  let tableHeader
  switch (type) {
    case 'CHECKBOX':
      tableHeader = (
        <th className='w-25px'>
          <label className='form-check form-check-sm form-check-custom form-check-solid me-5'>
            <input
              className='datatable-cell-center datatable-cell datatable-cell-check form-check-input bg-light-primary'
              type='checkbox'
              name='selectAll'
              id='selectAll'
              onChange={(e) => checkboxHandler()}
              checked={selectedCount === paginatedCount}
            />
          </label>
        </th>
      )
      break
    default:
      tableHeader = <th className={`min-w-${columnWidth}px ps-0 header_title`}>{headerName}</th>
  }
  return tableHeader
}

export const renderTableData = (apiDataValues: any, config: any) => {
  const {apiFieldName, type, headerName} = config
  let tableData
  switch (type) {
    case 'TEXT':
      tableData = checkEmptyData(apiDataValues[apiFieldName])
      break
    case 'MULTILEVEL_TEXT':
      tableData = checkEmptyData(`${apiDataValues}.${apiFieldName}`)
      break
    case 'ACTIVE_BADGE':
      tableData =
        apiDataValues[apiFieldName] === null ? (
          <div className={`badge badge-light-danger`}>Inactive</div>
        ) : (
          activeStatusBadge(apiDataValues[apiFieldName])
        )
      break
    case 'STATUS_BADGE':
      tableData = statusBadge(apiDataValues[apiFieldName])
      break
    case 'CHECKBOX':
      tableData = (
        <label className='form-check form-check-sm form-check-custom form-check-solid me-5 '>
          <input
            className='form-check-input bg-light-primary'
            type='checkbox'
            name={headerName}
            id='id'
            onChange={() => console.log('change')}
            checked={true}
          />
        </label>
      )
      break
    case 'SPACE_SEPERATED':
      tableData = `${
        Boolean(apiDataValues[config.apiFieldNameFirst])
          ? apiDataValues[config.apiFieldNameFirst]
          : ''
      } ${
        Boolean(apiDataValues[config.apiFieldNameSecond])
          ? apiDataValues[config.apiFieldNameSecond]
          : ''
      }`
      break
    case 'COMMA_SEPERATED':
      tableData = joinDataByCharacter(
        checkEmptyData(apiDataValues[config.apiFieldNameFirst]),
        checkEmptyData(apiDataValues[config.apiFieldNameSecond]),
        ','
      )
      break
    case 'COMMA_SEPERATED_ARRAY_OF_OBJECT':
      let temp = apiDataValues[config.apiFieldName].map((value: any) => value[config.objectName])
      tableData = temp.join(',')
      break
    case 'SLASH_SEPERATED':
      tableData = joinDataByCharacter(
        checkEmptyData(apiDataValues[config.apiFieldNameFirst]),
        checkEmptyData(apiDataValues[config.apiFieldNameSecond]),
        '/'
      )
      break
    case 'LOCALTIME':
      tableData = moment.utc(apiDataValues[config.apiFieldName]).local().format('ll, hh:mm A')
      break
    case 'LOCALTIME_SLASHSEPERATED':
      if (apiDataValues[config.apiFieldNameFirst] && apiDataValues[config.apiFieldNameSecond]) {
        tableData = joinDataByCharacter(
          moment.utc(apiDataValues[config.apiFieldNameFirst]).local().format('ll, hh:mm A'),
          moment.utc(apiDataValues[config.apiFieldNameSecond]).local().format('ll, hh:mm A'),
          ','
        )
      } else {
        tableData = '-'
      }
      break
    case 'PHONE_NUMBER':
      let phonerNumber = apiDataValues[apiFieldName]
      if (Boolean(phonerNumber)) {
        tableData = ` +1 ${phonerNumber.slice(0, 3)} ${phonerNumber.slice(
          3,
          6
        )} ${phonerNumber.slice(6, 10)}`
      } else {
        tableData = '-'
      }
      break
    case 'SUBSCRIPTION':
      tableData = (
        <span
          style={{textTransform: 'capitalize'}}
          className={`badge ${
            apiDataValues[apiFieldName] ? 'badge badge-light-success' : 'badge badge-light-danger'
          }`}
        >
          {apiDataValues[apiFieldName] ? 'SUBSCRIBED' : 'UNSUBSCRIBED'}
        </span>
      )
      break
    case 'IMAGE':
      tableData = (
        <img
          src={require(`../../../_metronic/images/${apiDataValues[apiFieldName]}`)}
          alt='phone'
        />
      )
      break
    default:
      tableData = ''
  }
  return tableData
}

const activeStatusBadge = (isActive: boolean) => {
  return (
    <div className={`badge badge-light-${isActive ? 'success' : 'danger'}`}>
      {isActive ? 'Active' : 'Inactive'}
    </div>
  )
}

const joinDataByCharacter = (
  firstData: string | number | null,
  secondData: string | number | null,
  character: string
) => `${firstData}${character}${secondData}`

const statusBadge = (status: string) => (
  <span style={{textTransform: 'capitalize'}} className={`badge ${statusBadgeClassName(status)}`}>
    {status}
  </span>
)
